export const events = {
  eventsCardDurationText: 'duur',
  eventsSearchInputText: 'Zoeken',
  eventsRegisteredToEventAlertTitle: 'Succesvol geregistreerd',
  eventsUnregisteredToEventAlertTitle: 'Succesvol geannuleerd',
  eventsExternalRegistrationPopupTitle: 'Registreren',
  eventsExternalRegistrationPopupContent: 'Bent u succesvol geregistreerd?',
  eventsExternalRegistrationNoButtonTitle: 'Nee',
  eventsExternalRegistrationYesButtonTitle: 'Ja',
  eventsCurtainCopyOptionTitle: 'Kopieer link',
  eventsCurtainFlagOptionTitle: 'Meld inhoud',
  eventsLinkCopiedAlertText: 'Link gekopieerd!',
  eventsCurtainAddToCalendOptionTitle: 'Toevoegen aan kalender',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'Op kaart',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Aanwezigen',
  eventdetailsSeeAllButtonTitle: 'Bekijk alles',
  eventdetailsRegisteredButtonTitle: 'Geregistreerd',
  eventdetailsRegisterButtonTitle: 'Registreren',
  eventdetailsRegisteredAlertText: 'Succesvol geregistreerd',
  eventdetailsUnregisteredAlertText: 'Succesvol geannuleerd',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Geregistreerde gebruikers',
  eventdetailsSpeakersCurtainTitle: 'Sprekers',
  eventdetailsSpeakersSectionTitle: 'Sprekers',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Bekijk alles',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Bekijk alles',
  eventdetailsCurtainCopyOptionTitle: 'Kopieer link',
  eventdetailsCurtainFlagOptionTitle: 'Meld inhoud',
  eventsdetailsLinkCopiedAlertText: 'Link gekopieerd!',
  eventdetailsCurtainAddToCalOptionTitle: 'Toevoegen aan kalender',
  eventDetailsAddCalendarPopupTitle: 'Kalender',
  eventdetailsAddCalendarPopupContent: 'Toevoegen aan kalender?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Nee',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Ja',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Kopieer link',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Meld inhoud',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Link gekopieerd!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Kopieer link',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Meld inhoud',
  eventsFlag: 'Melding',
  eventsJoin: 'Doe mee',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Link gekopieerd!',
  eventContentReported: 'Inhoud gemeld',
  eventsError: 'Er is iets misgegaan!',
  eventdetailsExternalRegistrationPopupContent: 'Bent u succesvol geregistreerd?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Nee',
  eventdetailsExternalRegistrationYesButtonTitle: 'Ja',
  eventdetailsExternalRegistrationPopupTitle: 'Registreren',
  eventsCardRegisteredButtonTitle: 'Geregistreerd',
  eventsCardRegisterButtonTitle: 'Registreren',
  eventsJoinLink: 'Link om deel te nemen: [url]{link}[/url][br]',
  eventsGuest: 'Gast',
  eventsNoSessionInDay: 'Geen evenementen deze dag.',
  eventsShowUpcomingEvent: 'Toon aankomend evenement'
}
